class GlobalEventHandler {
  constructor() {
    document.addEventListener('click', this.superClass_HandleClick.bind(this));
    document.addEventListener('change', this.superClass_HandleChange.bind(this));
  }

  superClass_HandleClick(event) {
    this.overrideHandle_ClickTemplate(event);
  }

  superClass_HandleChange(event) {
    this.overrideHandle_ChangeTemplate(event);
  }

  overrideHandle_ClickTemplate(event) {
    return event;
  }

  overrideHandle_ChangeTemplate(event) {
    return event;
  }

}


